module.exports = __webpack_public_path__ + "img/W7027-full.0af212ff.jpg";